export function parseRadioOpts<T extends { [K in keyof T[0]]: T[0][K] }[]>(
  data: T,
  fieldKey: keyof T[0],
  fieldLabel: keyof T[0],
) {
  return data.map((item) => ({
    key: String(item[fieldKey]),
    label: String(item[fieldLabel]),
  }));
}
